import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchInventory } from '../actions/inventoryActions';

export default function useInventory() {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const { inventory, treeCacheId } = useSelector(
        ({ inventory }) => inventory
    );
    const selectedAgent = useSelector(({ basAgent }) => {
        const { basAgents, selectedAgentId } = basAgent;
        return basAgents[selectedAgentId];
    });

    // Fetch inventory, via redux action, if necessary
    useEffect(() => {
        if (!selectedAgent) {
            return;
        }
        if (loading) {
            return;
        }
        const runFetchInventory = async () => {
            setLoading(true);
            try {
                await dispatch(fetchInventory(selectedAgent));
                setLoading(false);
            } catch (error) {
                setLoading(false);
                throw error;
            }
        };
        runFetchInventory();
    }, [selectedAgent]);

    return { loading, inventory, treeCacheId };
}
